export default "__VITE_ASSET__5f35a0f7__"